import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import { useBugReportForm } from "@hooks/useBugReportForm";
import { FONT_HEADING } from "@/constants";
import { FormFieldsCard } from "./FormFieldsCard";
import { SeverityCard } from "./SeverityCard";
import { EvidenceCard } from "./EvidenceCard";
import { TriageAlert } from "./TriageAlert";
import { FormActions } from "./FormActions";
import { PageFooter } from "./PageFooter";

export function BugReportForm() {
  const { t } = useTranslation();
  const form = useBugReportForm();

  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 800,
            fontFamily: FONT_HEADING,
            mb: 1,
          }}
        >
          {t("form.title")}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
          }}
        >
          {t("form.subtitle")}
        </Typography>
      </Box>
      <Grid container spacing={3} sx={{ alignItems: "stretch" }}>
        <Grid size={{ xs: 12, md: 8 }} sx={{ display: "flex" }}>
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              minHeight: { md: 0 },
            }}
          >
            <FormFieldsCard
              app={form.app}
              email={form.email}
              description={form.description}
              onAppChange={form.setApp}
              onEmailChange={form.setEmail}
              onDescriptionChange={form.setDescription}
            />
          </Box>
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              height: "100%",
            }}
          >
            <SeverityCard
              severity={form.severity}
              onSeverityChange={form.setSeverity}
            />
            <EvidenceCard
              images={form.images}
              video={form.video}
              usedSlots={form.usedSlots}
              imageInputRefs={form.imageInputRefs}
              videoInputRef={form.videoInputRef}
              onImageSelect={form.handleImageSelect}
              onRemoveImage={form.handleRemoveImage}
              onVideoSelect={form.handleVideoSelect}
              onRemoveVideo={form.handleRemoveVideo}
            />
          </Box>
        </Grid>

        <Grid size={12}>
          <TriageAlert />
        </Grid>

        <Grid size={12}>
          <FormActions
            recaptchaRef={form.recaptchaRef}
            onRecaptchaChange={form.setRecaptchaToken}
            onReset={form.handleReset}
            onSubmit={form.handleSubmit}
            isFormValid={form.isFormValid}
            submitting={form.submitting}
          />
        </Grid>
      </Grid>
      <PageFooter />
    </Box>
  );
}
